import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import PortalLogin from '../components/PortalLogin';

const CustomerLogin = () => {
  const navigate = useNavigate();
  return (
    <PortalLogin
      subtitle="Customer Portal"
      icon={Building2}
      allowedRoles={['customer']}
      onSuccess={() => navigate('/customer/dashboard')}
      testIdPrefix="customer"
    />
  );
};

export default CustomerLogin;
